var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.8213L12 1.82129L17.5 10.8213H6.5ZM17.5 21.8213C16.25 21.8213 15.1875 21.3838 14.3125 20.5088C13.4375 19.6338 13 18.5713 13 17.3213C13 16.0713 13.4375 15.0088 14.3125 14.1338C15.1875 13.2588 16.25 12.8213 17.5 12.8213C18.75 12.8213 19.8125 13.2588 20.6875 14.1338C21.5625 15.0088 22 16.0713 22 17.3213C22 18.5713 21.5625 19.6338 20.6875 20.5088C19.8125 21.3838 18.75 21.8213 17.5 21.8213ZM3 21.3213V13.3213H11V21.3213H3ZM17.5 19.8213C18.2 19.8213 18.7917 19.5796 19.275 19.0963C19.7583 18.613 20 18.0213 20 17.3213C20 16.6213 19.7583 16.0296 19.275 15.5463C18.7917 15.063 18.2 14.8213 17.5 14.8213C16.8 14.8213 16.2083 15.063 15.725 15.5463C15.2417 16.0296 15 16.6213 15 17.3213C15 18.0213 15.2417 18.613 15.725 19.0963C16.2083 19.5796 16.8 19.8213 17.5 19.8213ZM5 19.3213H9V15.3213H5V19.3213ZM10.05 8.82129H13.95L12 5.67129L10.05 8.82129Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.0c4373772dc034dd4747c1a5f1f7bdde.svg";
export { ForwardRef as ReactComponent };